export enum PrintingTemplate {
  QRCODE = 'templateImpressao.jogo-padrao-qrcode',
  BARCODE_EAN13 = 'templateImpressao.jogo-padrao-barcode',
  BARCODE_ITF14 = 'templateImpressao.jogo-padrao-itf14',
  DEFAULT = 'templateImpressao.jogo-padrao', // ??
  DEFAULT_FER = 'templateImpressao.jogo-padrao-fer', // ??
  NO_SECTOR = 'templateImpressao.jogo-sem-setor', // ??
}

export const PrintingTemplateLabels = {
  [PrintingTemplate.QRCODE]: 'QR Code',
  [PrintingTemplate.BARCODE_EAN13]: 'Código de Barras EAN-13',
  [PrintingTemplate.BARCODE_ITF14]: 'Código de Barras ITF-14',
  [PrintingTemplate.DEFAULT]: 'Padrão',
  [PrintingTemplate.DEFAULT_FER]: 'Padrão FER',
  [PrintingTemplate.NO_SECTOR]: 'Sem Setor',
}
